import React, { type ReactNode } from 'react';
import { IntlProvider, createIntlCache, createIntl } from 'react-intl';
import type { IntlConfig } from 'react-intl';
import { isTestNodeEnv } from 'constants/config';
import messages from 'constants/locales/en-US/en-US.translations.json';

const US_TIMEZONES = new Set([
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'America/Anchorage',
  'America/Adak',
  'Pacific/Honolulu',
  'America/Phoenix',
  'America/Boise',
  'America/Detroit',
  'America/Indiana/Indianapolis',
  'America/Indiana/Knox',
  'America/Indiana/Marengo',
  'America/Indiana/Petersburg',
  'America/Indiana/Tell_City',
  'America/Indiana/Vevay',
  'America/Indiana/Vincennes',
  'America/Indiana/Winamac',
  'America/Juneau',
  'America/Kentucky/Louisville',
  'America/Kentucky/Monticello',
  'America/Menominee',
  'America/Metlakatla',
  'America/Nome',
  'America/North_Dakota/Beulah',
  'America/North_Dakota/Center',
  'America/North_Dakota/New_Salem',
  'America/Sitka',
  'America/Yakutat'
]);

const getTimeLocale = () => {
  if (isTestNodeEnv) return 'en-US';

  const testLocal = localStorage.getItem('env0_static_local');
  if (testLocal) return testLocal;

  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (US_TIMEZONES.has(tz)) return 'en-US';
  } catch {}
  return 'en-UK';
};

export const timeLocale = getTimeLocale();

const cache = createIntlCache();

const intlConfig: IntlConfig = {
  locale: timeLocale,
  messages
};

const Localization: React.FunctionComponent<{ children?: ReactNode }> = ({ children }) => {
  return <IntlProvider {...intlConfig}>{children}</IntlProvider>;
};

export const intl = createIntl(intlConfig, cache);

// react-intl logs MISSING_TRANSLATION for an unknown id even when a defaultMessage is given, so a
// caller holding a string that may be raw server text has to ask before formatting it.
export const isTranslationId = (id: string): id is keyof typeof messages => id in messages;

export default Localization;
